<template>
  <div class="login-root">
    <div class="loader" v-if="loading"></div>

    <div class="login-locale" aria-label="Language">
      <LocaleSwitcher />
    </div>

    <main class="login-page login-page--split">
      <div class="login-hero" aria-hidden="true">
        <div class="login-hero__image-wrap">
          <img
            class="login-hero__image"
            src="@/assets/login-hero.png"
            alt=""
          />
        </div>
        <div class="login-hero__overlay"></div>
      </div>

      <div class="login-panel">
        <div class="login-panel__inner">
          <img
            class="login-panel__logo"
            src="@/assets/STRATACACHE logo - White.svg"
            alt="STRATACACHE"
          />
          <h1 class="login-panel__title">{{ $t("login.formTitle") }}</h1>
          <p class="login-panel__subtitle">{{ $t("login.systemTitle") }}</p>

          <form class="login-form login-form--panel" @submit.prevent="loginUser">
            <label class="login-field" for="login-email">
              <span class="login-field__label">{{ $t("login.email") }}</span>
              <input
                id="login-email"
                v-model="form.email"
                class="login-field__input"
                type="text"
                autocomplete="username"
                required
              />
            </label>

            <label class="login-field" for="login-password">
              <span class="login-field__label">{{ $t("login.password") }}</span>
              <input
                id="login-password"
                v-model="form.password"
                class="login-field__input"
                type="password"
                autocomplete="current-password"
                required
              />
            </label>

            <button
              class="btn btn--login"
              type="submit"
              :disabled="loading"
              @click.prevent="loginUser"
            >
              {{ loading ? $t("login.signingIn") : $t("login.btnName") }}
            </button>
          </form>

          <div v-if="errors.length" class="login-panel__error" role="alert">
            <ul class="login-panel__error-list">
              <li v-for="(error, idx) in errors" :key="idx">{{ error }}</li>
            </ul>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import axios from 'axios';
import { routeNames } from '../js/routeNames';
import { encryptData } from '../js/utils/encrypt';
import LocaleSwitcher from './LocaleSwitcher.vue';

export default {
  components: {
    LocaleSwitcher,
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      errors: [],
      isAuthenticated: true,
      loading: false,
      token: '',
      permissions: [],
      role: '',
      admindetails: '',
      airline: ''
    };
  },
  computed: {
    routeNames: () => {
      return routeNames;
    },
  },
  methods: {
    loginUser(e) {
      this.errors = [];
      if (this.form.email == '' || this.form.password == '') {
        if (this.form.email == '') {
          this.errors.push('Email required.');
        }
        if (this.form.password == '') {
          this.errors.push('Password required.');
        }
        if (!this.errors.length) {
          return true;
        }
        e.preventDefault();
        return;
      }
      this.loading = true;
      axios
        .post(this.$hostName + '/login', this.form)
        .then((response) => {

          //encrypted isAuthenticated
          const secretKey = process.env.KEY || 'myscecretkey';
          const encryptedData = encryptData(this.isAuthenticated, secretKey);
          localStorage.setItem('Login', encryptedData);

          this.token = response.data.data.token;

          //encrypted token
          const encryptedTokenData = encryptData(this.token, secretKey);
          localStorage.setItem('token', encryptedTokenData);

          let data = Object.keys(response.data.data.permissions).map((key) => {
            return response.data.data.permissions[key].name;
          });
          this.permissions = data;
          this.role = response.data.data.roles[0];
          this.airline = response.data.data.airline;
          console.log('Here-------',response.data.data);

          // localStorage.setItem("permissions", JSON.stringify(this.permissions));
          let username = response.data.data.user.name;
          localStorage.setItem('username', username);

          //encrypt Permissions
          const encryptedPermissionData = encryptData(this.permissions, secretKey);
          const encryptedRoleData = encryptData(this.role, secretKey);
          const encryptedAirlineData = encryptData(this.airline, secretKey);
          localStorage.setItem('Permissions', encryptedPermissionData);
          localStorage.setItem('Role', encryptedRoleData);
          localStorage.setItem('Airline', encryptedAirlineData);

          this.$router.push({name: routeNames.flightManager});
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
        })
        .finally(() => {
          if (this.errors.name) {
            this.loading = false;
            this.errors = [this.errors.name[0]];
            return;
          } else {
            this.loading = false;
            location.reload();
          }
        });
    },
    goToRoute(route) {
      if (this.navOpen) this.toggleNav();
      if (route == this.$router.currentRoute.name) return;
      this.$router.push({ name: route });
    },
  },
};
</script>
<style scoped lang="scss">
$login-brand-blue: #253d99;
$login-brand-blue-hover: #1e3278;

.login-root {
  position: relative;
  min-height: 100vh;
  width: 100%;
}

.login-locale {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 100;
}

.login-locale ::v-deep .select-lang {
  min-height: 40px;
  padding: 0.5rem 2rem 0.5rem 0.75rem;
  font-size: 0.875rem;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #fff;
  color: #475569;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.login-locale ::v-deep .select-lang:focus {
  outline: none;
  border-color: $login-brand-blue;
  box-shadow: 0 0 0 3px rgba(37, 61, 153, 0.12);
}

.login-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  width: 100%;
  box-sizing: border-box;
}

.login-page--split {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(320px, 0.95fr);
  min-height: 100vh;
  max-width: 100%;
  padding: 0;
  place-items: stretch;
}

.login-hero {
  position: relative;
  min-height: 42vh;
  overflow: hidden;
  background: #f4f4f5;
}

.login-hero__image-wrap {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-hero__image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
}

.login-hero__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.04) 100%);
  pointer-events: none;
}

.login-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(1.5rem, 4vw, 3rem);
  background: #fafafa;
  border-left: 1px solid #e5e5e5;
  box-sizing: border-box;
}

.login-panel__inner {
  width: 100%;
  max-width: 400px;
}

.login-panel__logo {
  display: block;
  width: min(100%, 280px);
  height: auto;
  max-height: 64px;
  object-fit: contain;
  object-position: left center;
  margin-bottom: 2rem;
}

.login-panel__title {
  margin: 0 0 0.35rem;
  font-size: 1.75rem;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #111;
}

.login-panel__subtitle {
  margin: 0 0 1.75rem;
  font-size: 0.95rem;
  color: #64748b;
}

.login-form--panel {
  display: grid;
  gap: 1.15rem;
}

.login-field {
  display: grid;
  gap: 0.4rem;
  margin: 0;
}

.login-field__label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #475569;
  letter-spacing: 0.02em;
}

.login-field__input {
  width: 100%;
  padding: 0.72rem 0.85rem;
  font-size: 1rem;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #fff;
  color: #111;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;

  &:hover {
    border-color: #bbb;
  }

  &:focus {
    outline: none;
    border-color: $login-brand-blue;
    box-shadow: 0 0 0 3px rgba(37, 61, 153, 0.12);
  }
}

.btn--login {
  width: 100%;
  margin-top: 0.35rem;
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid $login-brand-blue;
  background: $login-brand-blue;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s ease, filter 0.15s ease;

  &:hover:not(:disabled) {
    background: $login-brand-blue-hover;
    filter: brightness(1.02);
    color: #fff;
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
}

.login-panel__error {
  margin: 1rem 0 0;
  font-size: 0.875rem;
  color: $login-brand-blue;
}

.login-panel__error-list {
  margin: 0;
  padding-left: 1.25rem;
}

.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(236, 234, 234, 0.85);
  background-image: url("../assets/loading.gif");
  background-size: 50px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 10000000;
}

@media (max-width: 900px) {
  .login-page--split {
    grid-template-columns: 1fr;
  }

  .login-hero {
    min-height: 32vh;
    max-height: 38vh;
  }

  .login-panel {
    border-left: 0;
    border-top: 1px solid #e5e5e5;
    padding-bottom: 2.5rem;
  }

  .login-locale {
    top: 0.75rem;
    right: 0.75rem;
  }
}
</style>
